import { Outlet, Navigate } from "react-router-dom";

const WarehouseRoutes = (props) => {
   return props.warehouse ? <Outlet /> : <Navigate to="/login" />;
};

export default WarehouseRoutes;
